/* global angular */

angular.module('AemCspsMillionChild')
  .factory('plusMinusValueFactory', plusMinusValueFactory)

plusMinusValueFactory.$inject = []

function plusMinusValueFactory () {
  function PlusMinusValue (defaultValue, minValue, maxValue, step) {
    this.default = defaultValue
    this.value = this.default
    this.min = minValue
    this.max = maxValue
    this.step = step
    this.stepPrecision = getPrecision(step)
    this.parseParams = function (prefix, params) {
      this.default = angular.isDefined(params[prefix + 'Default']) ? params[prefix + 'Default'] : this.default
      this.value = this.default
      this.min = angular.isDefined(params[prefix + 'Min']) ? params[prefix + 'Min'] : this.min
      this.max = angular.isDefined(params[prefix + 'Max']) ? params[prefix + 'Max'] : this.max
    }
    this.onChanged = function (success) {
      success && success()
    }
    this.onPlus = function (success) {
      var newValue = precisionRound(parseFloat(this.value) + this.step, this.stepPrecision)
      if (newValue <= this.max) {
        this.value = newValue
        success && success()
      }
    }
    this.onMinus = function (success) {
      var newValue = precisionRound(parseFloat(this.value) - this.step, this.stepPrecision)
      if (newValue >= this.min) {
        this.value = newValue
        success && success()
      }
    }
    function getPrecision (number) {
      return ~number.toString().indexOf('.') ? number.toString().split('.')[1].length : 0
    }
    function precisionRound (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    }
  }

  function create (defaultValue, minValue, maxValue, step) {
    return new PlusMinusValue(defaultValue, minValue, maxValue, step)
  }

  return {
    create: create
  }
}
